var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentsFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 2.49695C12.9937 2.49695 15.4199 4.92308 15.4199 7.91587C15.4199 10.9087 12.9937 13.3348 10.001 13.3348C7.00817 13.3348 4.58203 10.9087 4.58203 7.91587C4.58203 4.92308 7.00817 2.49695 10.001 2.49695",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 13.3347H14.1688",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 5.85148V5.16336",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 9.98025V10.6684",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80646 9.48896C8.98329 9.79078 9.3058 9.97739 9.6556 9.98028H10.4125C10.9082 9.99266 11.3323 9.62684 11.3928 9.13474C11.4533 8.64265 11.1304 8.185 10.6465 8.07698L9.35695 7.75288C8.87873 7.64084 8.56137 7.18694 8.62031 6.69931C8.67926 6.21168 9.09563 5.84648 9.58678 5.85162H10.3437C10.6938 5.85398 11.0168 6.04069 11.1935 6.34293",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.004 10H15.8369C16.7578 10 17.5043 10.7465 17.5043 11.6674V15.8358C17.5043 16.7566 16.7578 17.5031 15.8369 17.5031H4.16541C3.24455 17.5031 2.49805 16.7566 2.49805 15.8358V11.6674C2.49805 10.7465 3.24455 10 4.16541 10H4.99835",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsFinance);
export default __webpack_public_path__ + "static/media/Payments, Finance.c744dff198a3b655f5dfa1d11b43ae66.svg";
export { ForwardRef as ReactComponent };